import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-CloseTagShape",
  "use": "svg-icon-CloseTagShape-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol viewBox=\"0 0 10 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-CloseTagShape\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.05.5L5 4.55.95.5.5.95 4.55 5 .5 9.05l.45.45L5 5.45 9.05 9.5l.45-.45L5.45 5 9.5.95 9.05.5z\" fill=\"#000\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol